import React from "react";
import { Skeleton } from "antd";

const PageSkeleton = ({ type = "content" }) => {
  if (type === "blog-list") {
    return (
      <main className="site-container space-y-6 py-8" aria-label="Loading articles">
        <Skeleton.Node active className="!h-72 !w-full rounded-xl" />
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {Array.from({ length: 6 }).map((_, index) => (
            <div key={index} className="space-y-3">
              <Skeleton.Node active className="!h-48 !w-full rounded-lg" />
              <Skeleton active title={{ width: "80%" }} paragraph={{ rows: 2 }} />
            </div>
          ))}
        </div>
      </main>
    );
  }

  if (type === "blog-detail") {
    return (
      <main className="site-container space-y-6 py-8" aria-label="Loading article">
        <Skeleton active title={{ width: "70%" }} paragraph={false} />
        <Skeleton.Node active className="!mx-auto !h-64 !w-full rounded-lg md:!h-[420px]" />
        <div className="mx-auto max-w-4xl">
          <Skeleton active title={false} paragraph={{ rows: 12 }} />
        </div>
      </main>
    );
  }

  if (type === "cart") {
    return (
      <main className="site-container space-y-6 py-8" aria-label="Loading cart">
        <Skeleton active title={{ width: "30%" }} paragraph={false} />
        <div className="grid gap-8 lg:grid-cols-[1fr_320px]">
          <div className="space-y-4">
            {Array.from({ length: 3 }).map((_, index) => (
              <div key={index} className="flex gap-4 rounded-xl border p-4">
                <Skeleton.Node active className="!h-28 !w-28 shrink-0 rounded-lg" />
                <div className="flex-1 pt-2"><Skeleton active title={{ width: "65%" }} paragraph={{ rows: 2 }} /></div>
              </div>
            ))}
          </div>
          <Skeleton active paragraph={{ rows: 6 }} className="rounded-xl border p-5" />
        </div>
      </main>
    );
  }

  if (type === "dashboard") {
    return (
      <main className="site-container grid gap-8 py-8 lg:grid-cols-[280px_1fr]" aria-label="Loading dashboard">
        <Skeleton active title={{ width: "60%" }} paragraph={{ rows: 8 }} />
        <div className="space-y-5">
          <Skeleton active title={{ width: "40%" }} paragraph={false} />
          {Array.from({ length: 4 }).map((_, index) => (
            <div key={index} className="rounded-xl border p-5"><Skeleton active title={{ width: "45%" }} paragraph={{ rows: 2 }} /></div>
          ))}
        </div>
      </main>
    );
  }

  if (type === "product-list") {
    return (
      <main className="site-container space-y-6 py-6" aria-label="Loading products">
        <Skeleton active title={{ width: "25%" }} paragraph={false} />
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 xl:grid-cols-4">
          {Array.from({ length: 8 }).map((_, index) => (
            <div key={index} className="space-y-3">
              <Skeleton.Node active className="!h-auto !w-full !aspect-square rounded-lg" />
              <Skeleton active title={{ width: "80%" }} paragraph={{ rows: 2 }} />
            </div>
          ))}
        </div>
      </main>
    );
  }

  return (
    <main className="site-container grid gap-8 py-8 lg:grid-cols-[2fr_1fr]" aria-label="Loading page">
      <div className="space-y-5 rounded-xl border p-5">
        <Skeleton active title={{ width: "40%" }} paragraph={{ rows: 6 }} />
      </div>
      <div className="space-y-5 rounded-xl border p-5">
        <Skeleton active title={{ width: "55%" }} paragraph={{ rows: 5 }} />
        <Skeleton.Button active block size="large" />
      </div>
    </main>
  );
};

export default PageSkeleton;
